module.exports = __webpack_public_path__ + "static/img/qrcode_huozhu.e1d4fd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode_huozhu.png
// module id = PTZh
// module chunks = 1